import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityWorkflowRunsFetchFailedAction = {
	type: 'FACILITY_WORKFLOW_RUNS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityWorkflowRunsFetchFailedAction => ({
	type: 'FACILITY_WORKFLOW_RUNS_FETCH_FAILED',
	payload,
});
